import { NewMakerConditionTooltipMoF } from '../../../ConditionTooltipMo/F/Function/module/NewMakerConditionTooltipMoF.js';
import { NewMakerCallConditionPopupF } from '../../../CallConditionPopup/F/Function/module/NewMakerCallConditionPopupF.js';
import { is_real_mapping_confirm_popup } from '../../../CallConditionPopup/F/Function/callconditionpopup.js';
import { NewMakerConditionAgreeTextF } from '../../../ConditionAgreeText/F/Function/module/NewMakerConditionAgreeTextF.js';
import { NewMakerEndServiceF } from '@modules/NewMaker/EndService/F/Function/module/NewMakerEndServiceF.js';

export class ConditionChecker {
  constructor() {
    this.is_passed = false;
  }

  passed() {
    this.is_passed = true;
    NewMakerCallConditionPopupF.resetForNotShowingWarning();
  }

  isPassed() {
    return this.is_passed || !NewMakerConditionAgreeTextF.getAgreeTextData()?.length;
  }

  async reset() {
    this.is_passed = false;
    await NewMakerCallConditionPopupF.reset2();
  }

  async openConfirmModalMobile() {
    if (this.is_passed) return true;
    const is_done = this.isPassed() || !!(await NewMakerConditionTooltipMoF.open());

    if (is_done) {
      this.passed();
    }
    return is_done;
  }

  static canInstantiate() {
    return is_real_mapping_confirm_popup() || NewMakerEndServiceF.makerStatus.useMcon();
  }
}
